import React from 'react';
import { useIntl } from 'react-intl';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import { ChevronRightIcon } from '../SiteChrome/icons';

export const LinksSchema = ({ intl }) => ({
  title: intl.formatMessage({ id: 'Links', defaultMessage: 'Links' }),
  fieldsets: [{ id: 'default', title: 'Default', fields: ['links'] }],
  properties: {
    links: {
      title: intl.formatMessage({ id: 'Links', defaultMessage: 'Links' }),
      widget: 'object_list',
      schema: {
        title: intl.formatMessage({ id: 'Link', defaultMessage: 'Link' }),
        fieldsets: [
          { id: 'default', title: 'Default', fields: ['text', 'href'] },
        ],
        properties: {
          text: {
            title: intl.formatMessage({ id: 'Text', defaultMessage: 'Text' }),
          },
          href: {
            title: intl.formatMessage({ id: 'Link', defaultMessage: 'Link' }),
            widget: 'object_browser',
            mode: 'link',
            allowExternals: true,
            selectedItemAttrs: ['Title'],
          },
        },
        required: ['text', 'href'],
      },
    },
  },
  required: [],
});

export function LinksView({ data, isEditMode = false }) {
  const intl = useIntl();
  const links = (data.links || []).filter(
    (item) => isEditMode || (item.text?.trim() && item.href?.[0]?.['@id']),
  );
  if (!isEditMode && !links.length) return null;
  return (
    <div className="block bonn-links">
      {isEditMode && !links.length && (
        <p>
          {intl.formatMessage({
            id: 'Add links in the sidebar.',
            defaultMessage: 'Add links in the sidebar.',
          })}
        </p>
      )}
      <ul>
        {links.map((item) => {
          const row = (
            <>
              <span>
                {item.text ||
                  intl.formatMessage({ id: 'Link', defaultMessage: 'Link' })}
              </span>
              <ChevronRightIcon size={16} />
            </>
          );
          return (
            <li key={item['@id']}>
              {isEditMode ? (
                <span className="bonn-links-link">{row}</span>
              ) : (
                <UniversalLink
                  href={item.href[0]['@id']}
                  className="bonn-links-link"
                >
                  {row}
                </UniversalLink>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export function LinksEdit(props) {
  const {
    data,
    block,
    selected,
    onChangeBlock,
    blocksErrors,
    navRoot,
    contentType,
  } = props;
  const intl = useIntl();
  const schema = LinksSchema({ intl });
  return (
    <>
      <LinksView data={data} isEditMode />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          formData={data}
          block={block}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
          onChangeBlock={onChangeBlock}
          errors={blocksErrors}
          navRoot={navRoot}
          contentType={contentType}
        />
      </SidebarPortal>
    </>
  );
}
